import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export const HeroSection = () => {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 px-4 sm:px-6 lg:px-8 bg-navy overflow-hidden min-h-[90vh] flex items-center" data-id="element-48">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-49"></div>

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-8 items-center relative z-10" data-id="element-50">
        <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-51">
          <FadeIn data-id="element-52">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-53">
              Biblia Anti-Ansiedad:{' '}
              <span className="text-gold block mt-2" data-id="element-54">
                El Código de Paz para el Ataque de Pánico de las 3 AM
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-55">
            <h2 className="text-lg sm:text-xl text-cream-muted leading-relaxed mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-56">
              Detén la opresión en el pecho y silencia tus pensamientos
              intrusivos con el sistema de "Prescripción Bíblica" diseñado para
              calmar tu sistema nervioso en minutos.
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-57">
            <Button onClick={scrollToOffer} data-id="element-58">
              Descargar Biblia Anti-Ansiedad Ahora
            </Button>
            <p className="mt-4 text-sm text-cream-muted/70" data-id="element-59">
              Acceso inmediato y privado.
            </p>
          </FadeIn>
        </div>

        <div className="order-1 lg:order-2 flex justify-center lg:justify-end relative" data-id="element-60">
          <FadeIn delay={0.3} direction="left" data-id="element-61">
            <div className="relative" data-id="element-62">
              <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full transform scale-90" data-id="element-63"></div>
              <img src="https://cdn.magicpatterns.com/uploads/ukx8oACkz4S1zWNiimhFH2/biblia_antiansiedad.png" alt="Biblia Anti-Ansiedad en Tablet y Teléfono" className="relative z-10 w-full max-w-md lg:max-w-lg object-contain drop-shadow-2xl" data-id="element-64" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};